var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        "before-close": _vm.closeDialog,
        visible: _vm.isShow,
        "show-close":
          _vm.active == 3 ||
          _vm.isAllFailed ||
          (_vm.selectPrinterForm.isOnlyApply && _vm.isApplyOrderFinished),
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        width: "711px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c("printWarningTip", {
        attrs: {
          alertTitle: _vm.alertTitle,
          selectPrinterForm: _vm.selectPrinterForm,
        },
      }),
      !_vm.selectPrinterForm.isOnlyApply
        ? _c("div", { staticClass: "y-f y-f-jb y-f-a print-step" }, [
            _c("div", { staticClass: "step1 y-t-ac" }, [
              _c("div", { staticClass: "y-mb-5 y-p-r" }, [
                _vm.active == 1
                  ? _c("div", { staticClass: "print-text-icon text-active" }, [
                      _vm._v("1"),
                    ])
                  : _c("img", {
                      staticClass: "print-step-icon",
                      attrs: {
                        src: require("@/assets/images/dianshang/printFinish.png"),
                      },
                    }),
                _c("div", {
                  staticClass: "print-line",
                  class: {
                    "active-border": _vm.active == 2 || _vm.active == 3,
                  },
                }),
              ]),
              _c("span", { class: { "process-blue": _vm.active == 1 } }, [
                _vm._v("获取运单号"),
              ]),
            ]),
            _c("div", { staticClass: "step2 y-t-ac" }, [
              _c("div", { staticClass: "y-mb-5 y-p-r" }, [
                _vm.active !== 3
                  ? _c(
                      "div",
                      {
                        staticClass: "print-text-icon wait-gray",
                        class: { "text-active": _vm.active == 2 },
                      },
                      [_vm._v("2")]
                    )
                  : _c("img", {
                      staticClass: "print-step-icon",
                      attrs: {
                        src: require("@/assets/images/dianshang/printFinish.png"),
                      },
                    }),
                _c("div", {
                  staticClass: "print-line",
                  class: { "active-border": _vm.active == 3 },
                }),
              ]),
              _c(
                "span",
                {
                  class: {
                    "process-blue": _vm.active == 2,
                    "wait-gray-text": _vm.active == 1,
                  },
                },
                [_vm._v("开始打印")]
              ),
            ]),
            _c("div", { staticClass: "step3 y-t-ac" }, [
              _c("div", { staticClass: "y-mb-5" }, [
                _vm.active != 3
                  ? _c("div", { staticClass: "print-text-icon wait-gray" }, [
                      _vm._v("3"),
                    ])
                  : _c("img", {
                      staticClass: "print-step-icon",
                      attrs: {
                        src: require("@/assets/images/dianshang/printSuccess.png"),
                      },
                    }),
              ]),
              _c(
                "span",
                {
                  class: {
                    "process-blue": _vm.active == 3,
                    "wait-gray-text": _vm.active != 3,
                  },
                },
                [_vm._v("打印成功")]
              ),
            ]),
          ])
        : _vm._e(),
      _vm.selectPrinterForm.isOnlyApply && _vm.isApplyOrderFinished
        ? _c("div", { staticClass: "successAll" }, [
            _c("i", { staticClass: "el-icon-success" }),
            _c("p", [_vm._v("全部获取成功")]),
          ])
        : _vm._e(),
      _vm.active == 1 && !_vm.isApplyOrderFinished
        ? _c("div", { staticClass: "tip-desp" }, [
            _vm._v("正在为："),
            _c("span", { staticClass: "y-fc-4C84FF" }, [
              _vm._v(_vm._s(_vm.curOrderNumber)),
            ]),
            _vm._v(" 获取运单，等待中请勿操作当前页面"),
          ])
        : _vm._e(),
      _vm.active == 2
        ? _c(
            "div",
            { staticClass: "tip-desp y-fs-16" },
            [
              _c("div", [_vm._v("正在向打印机发送数据......")]),
              _c("el-progress", {
                staticStyle: { width: "400px", margin: "0 auto" },
                attrs: { percentage: _vm.printPercentage, "stroke-width": 8 },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.active == 3
        ? _c("div", { staticClass: "tip-desp y-fs-16" }, [
            _vm._v("打印机打印完成后，请在 "),
            _c("span", { staticClass: "y-fc-4C84FF" }, [_vm._v("已打印")]),
            _vm._v(" 界面查看打印记录"),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "600px",
            title: "运单号获取详情",
            "custom-class": "applyErrorAlert",
            visible: _vm.innerVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.closeInnerDiaolg,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.innerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _vm.successList.length
                ? _c("div", [
                    _c("div", { staticClass: "y-mb-15" }, [
                      _vm._v(
                        "本次共选择了 " +
                          _vm._s(_vm.data.length) +
                          " 个订单，应获取 " +
                          _vm._s(
                            _vm.selectPrinterForm.isMultiWaybill &&
                              _vm.selectPrinterForm.manyWayBillNum > 1
                              ? _vm.data.length *
                                  _vm.selectPrinterForm.manyWayBillNum
                              : _vm.data.length
                          ) +
                          " 个运单号;"
                      ),
                    ]),
                    _c("div", { staticClass: "y-mb-15" }, [
                      _vm._v("已成功为 "),
                      _c("span", { staticClass: "y-fc-36C626" }, [
                        _vm._v(
                          _vm._s(
                            _vm.selectPrinterForm.isMultiWaybill &&
                              _vm.selectPrinterForm.manyWayBillNum > 1
                              ? _vm.data.length - _vm.failedList.length
                              : _vm.successList.length
                          )
                        ),
                      ]),
                      _vm._v(" 个订单获取了 "),
                      _c("span", { staticClass: "y-fc-36C626" }, [
                        _vm._v(_vm._s(_vm.successList.length)),
                      ]),
                      _vm._v(" 个运单，有 "),
                      _c("span", { staticClass: "y-fc-F56C6C" }, [
                        _vm._v(_vm._s(_vm.failedList.length)),
                      ]),
                      _vm._v(" 个订单获取运单号失败。"),
                    ]),
                  ])
                : _c("div", { staticClass: "y-mb-15" }, [
                    _vm._v(
                      "本次共选择了 " + _vm._s(_vm.data.length) + " 个订单，均 "
                    ),
                    _c("span", { staticClass: "y-fc-F56C6C" }, [
                      _vm._v("未成功获取"),
                    ]),
                    _vm._v(" 运单"),
                  ]),
              _c(
                "el-table",
                { attrs: { data: _vm.failedList, "max-height": "400" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      property: "logisticNo",
                      label: "订单编号",
                      width: "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  scope.row.customLogisticNo ||
                                    scope.row.logisticNo
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { property: "errorMsg", label: "失败原因" },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "dialog-footer y-mt-20 y-t-ac" },
                [
                  !_vm.selectPrinterForm.isOnlyApply
                    ? _c("el-button", { on: { click: _vm.closeInnerDiaolg } }, [
                        _vm._v("放弃打印"),
                      ])
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      staticClass: "border-btn",
                      on: { click: _vm.copyOrderNoListFn },
                    },
                    [_vm._v("复制出错订单编号")]
                  ),
                  !_vm.selectPrinterForm.isOnlyApply
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.successList.length,
                          },
                          on: { click: _vm.continuePrintFn },
                        },
                        [_vm._v("只打印正常订单")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px", "text-align": "center" } },
        [
          _vm.active == 3 ||
          _vm.isAllFailed ||
          (_vm.selectPrinterForm.isOnlyApply && _vm.isApplyOrderFinished)
            ? _c(
                "el-button",
                {
                  staticClass: "y-w-100",
                  attrs: { type: "primary" },
                  on: { click: _vm.closeDialog },
                },
                [_vm._v("关闭")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }